module.exports = __webpack_public_path__ + "img/zuzhijiagou.6ee4ae91.png";